import { initTimers } from "./initTimers";
onmessage = (e) => {
    switch (e.data.type) {
        case 0 /* TimerMessageTypes.ExecuteWorker */:
            initTimers(e.data.url);
            break;
        default:
            break;
    }
};
